import React, { useState } from "react";
import "./Where_You_Are_Going.css";
import { Form } from "react-bootstrap";
import Yellow_BG_Btn from "../../common/common-btn/yellow-bg-btn/Yellow_BG_Btn";
import Common_Css from "../../common/common-css/Common_Css.css";
import { useNavigate } from "react-router-dom";
import Full_Screen_Modal from "../../full-screen-modal/Full_Screen_Modal";
import { Message_Lottie } from "../../lotties/message-lottie/Message_Lottie";
import Success_Modal from "../../success-modal/Success_Modal";
import { EnquireForm } from "../../../utils/apis/form/form";
import { useForm } from "react-hook-form";

const Where_You_Are_Going = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [apiError, setApiError] = useState("");
  const {
    register,
    handleSubmit,
    getValues, reset,
    formState: { errors },
  } = useForm();
  const handleSend = () => {
    setShowModal(true);

    // setTimeout(() => {
    //   setShowModal(false);
    //   navigate("/");
    // }, 2500);
  };
  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    try {

      const sendData = new FormData();

      sendData.append("name", data?.name || "");
      sendData.append("email", data?.email || "");
      sendData.append("contact_no", data?.contact_no || "");
      sendData.append("message", data?.message || "");
      const response = await EnquireForm(sendData);
      if (response.success) {
        reset()
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 2500);
      } else {
        setApiError(response?.errors)
        console.error("Form submission failed:", response?.errors);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };


  return (
    <section className="Where_You_Are_Going">
      <div className="container container_div">
        <div className="row align-items-center mb-5">
          <div className="col-lg-5 col-md-8 col-12">
            <div className="left_col_div">
              <h5 className="left_col_header">
                Where You're Going,
                <br />
                We'rer Already There
              </h5>
              <p className="left_col_desc">
                Experience the majestic landscapes of Leh-Ladakh with the
                region’s most reliable & professional cab service. At Infinity
                Ladakh Taxi, we don’t just provide a ride; we provide a local
                companion for your Himalayan adventure.
              </p>

              <div className="col_features_div">
                <div className="feature_item">
                  <div className="outer_div">
                    <div className="feature_icon ">
                      <img
                        src="/assets/images/home/Where_You_Are_Going/professional.png"
                        alt="icon-1"
                        className="icon"
                      />
                    </div>
                  </div>
                  <span className="feature_text">Professional</span>
                </div>

                <div className="feature_item">
                  <div className="outer_div">
                    <div className="feature_icon ">
                      <img
                        src="/assets/images/home/Where_You_Are_Going/Certified.png"
                        alt="icon-2"
                        className="icon"
                      />
                    </div>
                  </div>

                  <span className="feature_text">Certified</span>
                </div>
              </div>

              <div className="about_us" onClick={() => navigate("/about-us")}>
                <p className="about">About Us</p>
              </div>
            </div>
          </div>

          <div className="col-lg-7 col-md-12 col-12">
            <div className="right_col_div">
              {/* CAR IMAGE */}

              {/* CAR IMAGE WRAPPER */}
              <div className="car_image_wrapper">
                {/* Default Image */}
                <img
                  src="/assets/images/home/Where_You_Are_Going/before-img.png"
                  alt="car-default"
                  className="car_img default_img"
                />

                {/* Hover Image */}
                <img
                  src="/assets/images/home/Where_You_Are_Going/after-img.png"
                  alt="car-hover"
                  className="car_img hover_img"
                />
              </div>

              <div className="enquiry_box">
                <h4 className="form_title">Enquire here...</h4>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className="custom_input"
                      {...register("name", {
                        required: "Name is required",
                      })}
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name.message}</small>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      className="custom_input"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^\S+@\S+$/i,
                          message: "Invalid email",
                        },
                      })}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email.message}</small>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      placeholder="Contact Number"
                      type="text"
                      className="custom_input"
                      name="contact_no"
                      maxLength={10} // restrict typing to 10 digits
                      {...register("contact_no", {
                        required: "Contact Number is required",
                        pattern: {
                          value: /^[0-9]+$/,  // only numbers
                          message: "Only digits are allowed",
                        },
                        minLength: {
                          value: 10,
                          message: "Contact Number must be exactly 10 digits",
                        },
                        maxLength: {
                          value: 10,
                          message: "Contact Number must be exactly 10 digits",
                        },
                      })}
                    />

                    {errors.contact_no && (
                      <span className="text-danger">{errors?.contact_no?.message}</span>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Message"
                      className="custom_input"
                      {...register("message", {
                        required: "Message is required",
                      })}
                    />
                    {errors.message && (
                      <small className="text-danger">{errors.message.message}</small>
                    )}
                  </Form.Group>

                  {/* <div
                  // className="form_btn_holder"

                  > */}
                  <Yellow_BG_Btn text="Send" onClick={handleSubmit(onSubmit)} />
                  {/* </div> */}

                  {apiError && (
                    <span className="error">{apiError}</span>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Success_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        successText="Form Submitted!"
      />
    </section>
  );
};

export default Where_You_Are_Going;
